import httpClient from "../lib/HttpClient";

/**
 * Finds the library the in-app help chat talks to.
 *
 * GET /help_library returns { id, name, escalation } for the one library flagged
 * as the installation's help library, or 404 when none is flagged. The result is
 * fetched once per page load and shared by the header menu item and the panel.
 */
class HelpLibrary {
  constructor() {
    this.library = null;
    this.loaded = false;
    this.pending = null;
  }

  /**
   * Loads the help library, reusing an in-flight or finished request.
   *
   * @returns {Promise<Object|null>} resolves with { id, name, escalation }, or
   *   null when the installation has no help library (404) or the request failed
   */
  load = () => {
    var _this = this;

    if (this.loaded) {
      return Promise.resolve(this.library);
    }

    if (this.pending) {
      return this.pending;
    }

    this.pending = httpClient
      .get("/help_library")
      .then(function (response) {
        _this.library = response.data;
        _this.loaded = true;
        return _this.library;
      })
      .catch(function (error) {
        var isNotFound =
          error && error.response && error.response.status === 404;
        if (!isNotFound) {
          console.error("Error loading help library:", error);
        }
        _this.library = null;
        _this.loaded = true;
        return null;
      })
      .finally(function () {
        _this.pending = null;
      });

    return this.pending;
  };

  /**
   * @returns {Object|null} the help library once load() has resolved, else null
   */
  get = () => {
    return this.library;
  };

  /**
   * @returns {boolean} whether load() has resolved, so a null get() means "none"
   */
  isLoaded = () => {
    return this.loaded;
  };
}

export default new HelpLibrary();
